var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.219957 5.28C0.0792646 5.42052 0.000132084 5.61116 -4.29153e-05 5.81V6.19C0.00226116 6.38842 0.0810733 6.57828 0.219957 6.72001L5.35996 11.85C5.45384 11.9447 5.58164 11.9979 5.71496 11.9979C5.84828 11.9979 5.97607 11.9447 6.06996 11.85L6.77996 11.14C6.87402 11.0478 6.92703 10.9217 6.92703 10.79C6.92703 10.6583 6.87402 10.5322 6.77996 10.44L2.32996 6L6.77996 1.56C6.87461 1.46612 6.92786 1.33832 6.92786 1.205C6.92786 1.07169 6.87461 0.943888 6.77996 0.850005L6.06996 0.150005C5.97607 0.0553486 5.84828 0.00210571 5.71496 0.00210571C5.58164 0.00210571 5.45384 0.0553486 5.35996 0.150005L0.219957 5.28Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBack);
export default __webpack_public_path__ + "static/media/chevronBack.7d5f67a0.svg";
export { ForwardRef as ReactComponent };